import {Basic} from "./Basic";
import {Browser} from "./Browser";
import {Display} from "./Display";
import {Slider} from "./Slider";

window.addEventListener('DOMContentLoaded',function()
{
    // set variables
    Basic.init();

    // get environment
    Browser.analyze();
    Display.analyze();

    // get language from HTML
    Basic.lang = document.documentElement.lang;

    // remove hover class on mobile devices
    if(Browser.mobile === true)
    {
        document.body.classList.remove('w__hover');
        document.body.classList.add('w__mobile');
    }

    // add event listeners
    Basic.add_clickEvent();

    // active slider
    new Slider();
});

// window resize detection
window.addEventListener('resize',() =>
{
    cancelAnimationFrame(Basic.resizeTimer);
    Basic.resizeTimer = requestAnimationFrame(Basic.process_resize);
});